<template>
  <div v-if="showModal" class="side__modal opened" id="modal__adding__customers__docs">
    <div class="">
      <div class="side__modal__content">
        <div class="modal__top">
          <div class="modal__header">
            <h3 class="modal__title">{{ $lang.app.CERTIFYING_DOCUMENTS }}</h3>
            <span class="modal__close" @click="closeModal">
            <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
          </div>
          <p>{{ $lang.app.CERTIFYING_ESTABLISHING_DOCUMENTS }}</p>
        </div>

        <Form class="modal__footer"
              @submit="submit"
              :initial-values="docForm"
              :validation-schema="docSchema">
          <div class="input__group input__add__info">
            <label for="type-input" class="label">{{ $lang.app.TYPE }}</label>
            <div class="select__wrapper">
              <Field name="type" v-slot="{ field, errorMessage }">
                <Multiselect
                    id="type-input"
                    :class="{'select--fail': errorMessage }"
                    v-bind="field"
                    v-model="docForm.type"
                    :options="certifyingDocumentTypes"
                    :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                    :searchable="true"
                    :noOptionsText="$lang.app.LIST_EMPTY"
                    :noResultsText="$lang.app.NOT_FOUND"
                    :can-clear="false">
                </Multiselect>
                <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
              </Field>
            </div>
          </div>
          <div class="input__group">
            <label for="name-input" class="label">{{ $lang.app.DENOMINATION }}</label>
            <Field name="name" v-slot="{ field, errorMessage }">
              <input v-bind="field"
                     type="text"
                     id="name-input"
                     v-model="docForm.name"
                     class="input"
                     :class="{'input--fail': errorMessage }"
                     :placeholder="$lang.app.ENTER">
              <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
            </Field>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="input__group">
                <label for="number-input" class="label">{{ $lang.app.DOCUMENT_NUMBER }}</label>
                <Field name="number" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="number-input"
                         v-model="docForm.number"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input__group">
                <label for="doc-date-input" class="label">{{ $lang.app.DATE }}</label>
                <Field name="docDate" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="date"
                         id="doc-date-input"
                         v-model="docForm.docDate"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
          </div>
          <div class="input__groups">
            <label for="file-input" class="label label__file mb-4">
              <span v-if="docForm.fileDemo">{{ docForm.fileDemo.name }}</span>
              <span v-else>
              <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
              </svg>
            {{ $lang.app.ADD_FILE }}
            </span>
            </label>
            <Field type="file" name="fileDemo" accept="application/pdf"
                   id="file-input"
                   class="input__file hidden"
                   @change="event => docForm.fileDemo = event.target.files[0]"/>
            <ErrorMessage name="fileDemo" class="input__fail"/>
          </div>
          <div class="between__buttons">
            <button type="button" class="button button__modal__close button--cancel"
                    @click="closeModal">{{ $lang.app.CANCEL }}</button>
            <button type="submit" class="relative button button__modal__close"
                    :disabled="submitting">
              {{ $lang.app.UPDATE }}
              <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
                <div class="block animate-spin">
                  <RefreshIcon class="w-6 h-6 mirror-y"/>
                </div>
              </div>
            </button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import * as yup from "yup";
import {Field, Form, ErrorMessage} from 'vee-validate';
import applicationApi from "../../../../api/applicant/application";
import {
  all as certifyingDocumentTypesAll,
} from "../../../../helpers/constants/certifyingDocumentTypes";
import fileUploadMixin from "../../../../mixins/fileUploadMixin";
import {
  getValueByKey as userTypesGetValueByKey,
  getLabelRefByValue as userTypesGetLabelRefByValue,
} from "../../../../helpers/constants/userTypes";

export default {
  name: 'ApplicantApplicationApplicantCertDocEditModal',
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  mixins: [fileUploadMixin],
  data() {
    return {
      showModal: false,
      doc: null,
      applicant: null,

      submitting: false,

      certifyingDocumentTypes: this.certifyingDocumentTypesAll().map(item => ({
        label: this.$lang.app[item.labelRef],
        value: item.value
      })),

      docForm: null,

      docSchema: yup.object({
        type: yup.mixed().required(),
        name: yup.string().required(),
        number: yup.mixed().required(),
        docDate: yup.mixed().required(),
      }),
    }
  },
  beforeMount() {
    this.$emitter.on('open-applicant-application-applicant-cert-doc-edit-modal', (payload) => {
      this.applicant = payload.applicant
      this.doc = payload.doc
      this.docForm = {
        type: payload.doc.type,
        name: payload.doc.name,
        number: payload.doc.number,
        docDate: this.$moment(payload.doc.docDate).format('YYYY-MM-DD'),
        file: payload.doc.file?.id,
        fileDemo: null,
      }

      this.openModal()
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-applicant-application-applicant-cert-doc-edit-modal')
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    certifyingDocumentTypesAll,
    userTypesGetValueByKey,
    userTypesGetLabelRefByValue,

    prepareFilesForSubmit() {
      if(this.docForm.fileDemo) {
        return new Promise((resolve, reject) => {
          this.uploadFile(this.docForm.fileDemo).then((res) => {
            this.docForm.file = res
            resolve(res)
          }).catch(error => {
            this.$snotify.error(error)

            reject(error)
          });
        })
      }
    },

    async submit(values, actions) {
      await this.prepareFilesForSubmit()
      this.submitting = true
      applicationApi.updateApplicantCertifyingDocument(this.applicant.id, this.doc.id, {
        type: this.docForm.type,
        name: this.docForm.name,
        number: this.docForm.number,
        docDate: this.docForm.docDate,
        file: this.docForm.file,
      })
          .then(() => {
            this.closeModal()
            this.$emitter.emit('refresh-application', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.setValidationErrors(actions, error.response.data.errors)
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(error)
            }
          }).finally(() => {
            this.submitting = false
      })
    }
  }
}
</script>